// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-layout-SearchLayout-SearchLayout-module__container-UmAh6W","sub":"src-app-components-layout-SearchLayout-SearchLayout-module__sub-EEH5V6","icon":"src-app-components-layout-SearchLayout-SearchLayout-module__icon-NmQdde"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-layout-SearchLayout-SearchLayout-module__container-UmAh6W\",\"sub\":\"src-app-components-layout-SearchLayout-SearchLayout-module__sub-EEH5V6\",\"icon\":\"src-app-components-layout-SearchLayout-SearchLayout-module__icon-NmQdde\"}";
        // 1789362522797
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  